// extracted by mini-css-extract-plugin
export default {"bg":"BackGround_bg__o0Oae","path":"BackGround_path__lb43q","dash":"BackGround_dash__VwN6k"};